<section class="account-dialog">
  <header class="account-dialog__header">
    <div>
      <h2 id="account-change-password-title" class="account-dialog__title">
        {{ 'account.changePassword.title' | translate }}
      </h2>
      <p id="account-change-password-description" class="account-dialog__description">{{ 'account.changePassword.description' | translate }}</p>
    </div>

    <button
      type="button"
      class="account-dialog__close"
      [attr.aria-label]="'account.dialog.close' | translate"
      (click)="close()"
    >
      <span class="material-symbols-outlined account-dialog__close-icon" aria-hidden="true">close</span>
    </button>
  </header>

  @if (errorMessageKey(); as errorKey) {
    <p class="account-dialog__alert" role="alert">{{ errorKey | translate }}</p>
  }

  <form class="account-dialog__form" [formGroup]="form" [attr.aria-busy]="isSubmitting()" (ngSubmit)="submit()">
    <div class="account-dialog__field">
      <label class="account-dialog__label" for="account-current-password">
        {{ 'account.changePassword.currentPassword' | translate }}
      </label>
      <input
        id="account-current-password"
        class="account-dialog__input"
        type="password"
        required
        formControlName="currentPassword"
        autocomplete="current-password"
        enterkeyhint="go"
      />
    </div>

    <div class="account-dialog__field">
      <label class="account-dialog__label" for="account-new-password">
        {{ 'account.changePassword.newPassword' | translate }}
      </label>
      <input
        id="account-new-password"
        class="account-dialog__input"
        [class.account-dialog__input--invalid]="form.controls.newPassword.invalid && form.controls.newPassword.touched"
        type="password"
        required
        formControlName="newPassword"
        autocomplete="new-password"
        enterkeyhint="go"
        placeholder="********"
        [attr.aria-invalid]="form.controls.newPassword.invalid && form.controls.newPassword.touched"
        [attr.aria-describedby]="form.controls.newPassword.invalid && form.controls.newPassword.touched ? 'account-new-password-error' : null"
      />
      @if (form.controls.newPassword.invalid && form.controls.newPassword.touched) {
        <p id="account-new-password-error" class="account-dialog__hint account-dialog__hint--error">
          {{ 'account.changePassword.constraints' | translate }}
        </p>
      }
    </div>

    <div class="account-dialog__field">
      <label class="account-dialog__label" for="account-confirm-password">
        {{ 'account.changePassword.confirmPassword' | translate }}
      </label>
      <input
        id="account-confirm-password"
        class="account-dialog__input"
        [class.account-dialog__input--invalid]="form.hasError('passwordMismatch') && form.controls.confirmNewPassword.touched"
        type="password"
        required
        formControlName="confirmNewPassword"
        autocomplete="new-password"
        enterkeyhint="go"
        placeholder="********"
        [attr.aria-invalid]="form.hasError('passwordMismatch') && form.controls.confirmNewPassword.touched"
        [attr.aria-describedby]="form.hasError('passwordMismatch') && form.controls.confirmNewPassword.touched ? 'account-confirm-password-error' : null"
      />
      @if (form.hasError('passwordMismatch') && form.controls.confirmNewPassword.touched) {
        <p id="account-confirm-password-error" class="account-dialog__hint account-dialog__hint--error">
          {{ 'account.changePassword.mismatch' | translate }}
        </p>
      }
    </div>

    <div class="account-dialog__actions">
      <button type="button" class="account-dialog__secondary" (click)="close()">
        {{ 'account.dialog.cancel' | translate }}
      </button>
      <button type="submit" class="account-dialog__primary" [disabled]="form.invalid || isSubmitting()">
        {{ isSubmitting() ? ('account.dialog.saving' | translate) : ('account.changePassword.submit' | translate) }}
      </button>
    </div>
  </form>
</section>
